import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/components/index'], resolve)
    },
    {
      path: '/zongshu',
      name: 'zongshu',
      component: resolve => require(['@/components/zongshu'], resolve)
    },
    {
      path: '/cap',
      name: 'cap',
      component: resolve => require(['@/components/cap'], resolve)
    },
    {
      path: '/syl',
      name: 'syl',
      component: resolve => require(['@/components/syl'], resolve)
    },
    {
      path: '/profit',
      name: 'profit',
      component: resolve => require(['@/components/profit'], resolve)
    },
    {
      path: '/sjl',
      name: 'sjl',
      component: resolve => require(['@/components/sjl'], resolve)
    },
    {
      path: '/sjze',
      name: 'sjze',
      component: resolve => require(['@/components/sjze'], resolve)
    },
    {
      path: '/szzl',
      name: 'szzl',
      component: resolve => require(['@/components/szzl'], resolve)
    },
    {
      path: '/sector',
      name: 'sector',
      component: resolve => require(['@/components/sector'], resolve)
    },
    {
      path: '/company/:id',
      name: 'company',
      component: resolve => require(['@/components/company'], resolve)
    }, 
    {
      path: '/sources',
      name: 'sources',
      component: resolve => require(['@/components/sources'], resolve)
    }, {
      path: '/copyright',
      name: 'copyright',
      component: resolve => require(['@/components/copyright'], resolve)
    }, {
      path: '/organization',
      name: 'organization',
      component: resolve => require(['@/components/organization'], resolve)
    }, {
      path: '/contact',
      name: 'contact',
      component: resolve => require(['@/components/contact'], resolve)
    },
    //english
    {
      path: '/english',
      name: 'english',
      component: resolve => require(['@/components/english'], resolve)
    },
    {
      path: '/zongshuEn',
      name: 'zongshuEn',
      component: resolve => require(['@/components/zongshuEn'], resolve)
    },
    {
      path: '/capEn',
      name: 'capEn',
      component: resolve => require(['@/components/capEn'], resolve)
    },
    {
      path: '/sylEn',
      name: 'sylEn',
      component: resolve => require(['@/components/sylEn'], resolve)
    },
    {
      path: '/profitEn',
      name: 'profitEn',
      component: resolve => require(['@/components/profitEn'], resolve)
    },
    {
      path: '/sjlEn',
      name: 'sjlEn',
      component: resolve => require(['@/components/sjlEn'], resolve)
    },
    {
      path: '/sjzeEn',
      name: 'sjzeEn',
      component: resolve => require(['@/components/sjzeEn'], resolve)
    },
    {
      path: '/szzlEn',
      name: 'szzlEn',
      component: resolve => require(['@/components/szzlEn'], resolve)
    },
    {
      path: '/sectorEn',
      name: 'sectorEn',
      component: resolve => require(['@/components/sectorEn'], resolve)
    },
    {
      path: '/companyEn/:id',
      name: 'companyEn',
      component: resolve => require(['@/components/companyEn'], resolve)
    }, 
    {
      path: '/sourcesEn',
      name: 'sourcesEn',
      component: resolve => require(['@/components/sourcesEn'], resolve)
    }, {
      path: '/copyrightEn',
      name: 'copyrightEn',
      component: resolve => require(['@/components/copyrightEn'], resolve)
    }, {
      path: '/organizationEn',
      name: 'organizationEn',
      component: resolve => require(['@/components/organizationEn'], resolve)
    }, {
      path: '/contactEn',
      name: 'contactEn',
      component: resolve => require(['@/components/contactEn'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js